// extracted by mini-css-extract-plugin
export default {"button":"VNbf0zIRTJruPMFJLNo3","shineAnimation":"mtIKgU44so1FwM7r3FL_","ShineAnimation":"Z_oDJ2E1p5X48eKXZftA"};